import { render, staticRenderFns } from "./PropPlan.vue?vue&type=template&id=4e31763a&"
import script from "./PropPlan.vue?vue&type=script&lang=js&"
export * from "./PropPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports